import {
  Building2,
  Gauge,
  Bot,
  Brain,
  Activity,
  BarChart2,
  FileBarChart,
  Users,
  CreditCard,
  Radio,
} from 'lucide-react';

/** Sidebar sections for SuperAdmin company detail — matches the Dietitians row dropdown. */
export const SUPERADMIN_COMPANY_NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [{ label: 'Overview', path: '', icon: Building2, end: true }],
  },
  {
    title: 'AI Setting',
    items: [
      { label: 'AI Limits', path: 'ai-limits', icon: Gauge },
      { label: 'AI Chat', path: 'ai-chats', icon: Bot },
      { label: 'AI Config', path: 'ai-config', icon: Brain },
      { label: 'AI Health', path: 'ai-health', icon: Activity },
    ],
  },
  {
    title: 'AI Reports',
    items: [
      {
        label: 'AI Usage',
        path: 'reports',
        search: '?tab=ai_breakdown',
        tab: 'ai_breakdown',
        icon: BarChart2,
      },
      {
        label: 'AI Usage Report',
        path: 'reports',
        search: '?tab=ai_usage',
        tab: 'ai_usage',
        icon: FileBarChart,
      },
      {
        label: 'Customers using AI',
        path: 'reports',
        search: '?tab=ai_customers',
        tab: 'ai_customers',
        icon: Users,
      },
    ],
  },
  {
    title: 'Customer payments',
    items: [
      { label: 'Allowed customer gateways', path: 'gateways', icon: CreditCard },
    ],
  },
  {
    title: 'Media',
    items: [{ label: 'Media Server', path: 'media-server', icon: Radio }],
  },
];

export const SUPERADMIN_COMPANY_QUICK_LINKS = [
  {
    label: 'AI Limits',
    path: 'ai-limits',
    icon: Gauge,
    desc: 'Free, trial, and premium daily AI counts',
  },
  {
    label: 'AI Chat',
    path: 'ai-chats',
    icon: Bot,
    desc: 'View customer AI conversations',
  },
  {
    label: 'AI Config',
    path: 'ai-config',
    icon: Brain,
    desc: 'Models, prompts, TTS/STT',
  },
  {
    label: 'AI Health',
    path: 'ai-health',
    icon: Activity,
    desc: 'API health and usage',
  },
  {
    label: 'AI Usage',
    path: 'reports',
    search: '?tab=ai_breakdown',
    icon: BarChart2,
    desc: 'AI usage breakdown',
  },
  {
    label: 'AI Usage Report',
    path: 'reports',
    search: '?tab=ai_usage',
    icon: FileBarChart,
    desc: 'Detailed AI usage report',
  },
  {
    label: 'Customers using AI',
    path: 'reports',
    search: '?tab=ai_customers',
    icon: Users,
    desc: 'Customers using AI',
  },
  {
    label: 'Allowed customer gateways',
    path: 'gateways',
    icon: CreditCard,
    desc: 'Gateways this dietitian may offer customers',
  },
  {
    label: 'Media Server',
    path: 'media-server',
    icon: Radio,
    desc: 'Assign a media server for audio/video calls',
  },
];
